import { ReactElement, useMemo } from 'react';
import { useCommonTranslation } from '../../../../../hooks/i18n/useCommonTranslation';
import { useRole } from '../../../../../context/RoleContext';
import { useSiteBooleanAttributes } from '../../../../../hooks/useAttribute';
import { SHOW_OVERFLOW_CALENDAR } from '../../../../../configs/siteAndTrustAttributes';
import { ROLE_OFFSITE_RECEPTIONIST } from '../../../../../configs/constants';
import { CommonButton } from '../../../../common/Forms/Button';

export interface OverflowButtonProps {
  onOverflowClicked: () => void;
}

export const OverflowButton = ({
  onOverflowClicked,
}: OverflowButtonProps): ReactElement => {
  const { t } = useCommonTranslation();
  const { hasAnyOfRoles } = useRole();

  const [showOverflowAttribute] = useSiteBooleanAttributes(
    SHOW_OVERFLOW_CALENDAR,
  );

  const showOverflow = useMemo(() => {
    return (
      showOverflowAttribute &&
      // Show overflow button only if:
      !hasAnyOfRoles(ROLE_OFFSITE_RECEPTIONIST)
    );
  }, [hasAnyOfRoles, showOverflowAttribute]);

  return showOverflow ? (
    <CommonButton
      variant={'secondary'}
      style={{
        borderColor: 'var(--textprimary)',
      }}
      onClick={onOverflowClicked}
    >
      {t('overflow')}
    </CommonButton>
  ) : (
    <></>
  );
};
